<template>
  <div :class="jel_getClassObject(content)" class="m-1">
    <div class="bloc-mise-avant w-100">
      <div class="bloc-mise-avant-contenu d-block h-100">
        <span class="type-bloc">{{ $tc(`messageComponent.${content.type.field}`) }}</span>
        <span class="texte-bloc pt-1" v-html="contenu" />
        <button class="bouton" @click="ouvertureZoneEscamotable()">
          {{
            content.type.field === 'section'
              ? $tc('messageComponent.voirQuestions')
              : $tc('messageComponent.voirReponse')
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { bus } from '@/main';

export default {
  name: 'ZoneEscamotableMiseAvant',
  props: { content: { type: Object, required: true } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          question: 'Question',
          section: 'Section',
          voirQuestions: 'Voir toutes les questions',
          voirReponse: 'Voir la réponse',
        },
      },
      en: {
        messageComponent: {
          question: 'Question',
          section: 'Section',
          voirQuestions: 'See all questions',
          voirReponse: 'See the answer',
        },
      },
    },
  },
  data() {
    return {
      apercu: null,
      reference: null,
    };
  },
  computed: {
    ...mapState(['aide']),
    contenu() {
      return this.apercu || this.content.type.texte;
    },
  },
  mounted() {
    if (this.content.type.field === 'section') {
      this.reference = this.content.type.idSection;
    } else {
      this.getAide();
    }
  },
  methods: {
    async getAide() {
      this.$store.dispatch('aide/initRubriqueAide', {
        idRubriqueAide: [this.content.type.idRubriqueAide],
      });

      await this.$store.dispatch('aide/toggleAide').then(() => {
        this.apercu = this.aide.listeQuestionsReponses[0].question;
        this.reference = this.aide.listeQuestionsReponses[0].name;
      });
    },
    ouvertureZoneEscamotable() {
      bus.$emit('ouvrirZoneEscamotable', this.reference);
    },
  },
};
</script>

<style lang="scss" scoped>
.bloc-mise-avant {
  position: relative;
  background-color: #dce1e580;
  border-radius: 15px;
  height: 140px;
}
.bloc-mise-avant-contenu {
  padding: 10px 14px;
}
.type-bloc {
  background-color: #ff355a;
  border-radius: 8px;
  color: #ffffff;
  font-family: graphik_semibold;
  font-size: 12px;
  padding: 4px 12px;
}
.texte-bloc,
.texte-bloc ::v-deep p {
  color: #060b32 !important;
  font-family: graphik_bold;
  font-size: 15px;
  line-height: 18px;
  padding-bottom: 0;

  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.bouton {
  position: absolute;
  bottom: 10px;
  right: 14px;

  background-color: #84b9ea;
  border: solid 2px #060b32;
  border-radius: 15px;
  color: #060b32;
  font-family: graphik_semibold;
  font-weight: 600;
  font-size: 14px;
}
</style>
